import { graphql } from "gql";

const DISTRIBUTION_GROUP_LIST_QUERY = graphql(`
  query DistributionGroupList {
    distributionGroupList {
      ...DistributionGroup
    }
  }
`);

export default DISTRIBUTION_GROUP_LIST_QUERY;
